import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organos-institucionales',
  templateUrl: './organos-institucionales.component.html',
  styleUrls: ['./organos-institucionales.component.css']
})
export class OrganosInstitucionalesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
